import MockAdapter from 'axios-mock-adapter/types'

export function mockWssToken(mocker: MockAdapter) {
  mocker.onGet('/users/wss/token').reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          result: '',
        },
      },
    ]
  })
}
